const handlebars = require('handlebars');

handlebars.registerHelper('padZero', function(text, size) {
  if (text != null) {
    return text
      .toString()
      .padStart(size, '0')
      .substr(-size);
  }
  return '';
});

handlebars.registerHelper('helperMissing', function(/* [args, ] options */) {
  var options = arguments[arguments.length - 1];
  throw new Error(`[Handlebars] Missing parameter ${options.name}`);
  return options.name;
});

module.exports = handlebars;



// WEBPACK FOOTER //
// ./src/services/handlebars.js